import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import ActionButton from '../components/ActionButton'

import { setFilter } from '../redux/actions/items'
import api from '../redux/api'

class DeleteMaintenanceTemplateButton extends React.Component {
  static propTypes = {
    // Props coming from parent
    maintenanceTemplate: PropTypes.object.isRequired,
    // Props coming from Redux
    filterCriteria:      PropTypes.object.isRequired,
    setFilter:           PropTypes.func.isRequired,
  }

  state = {
    modalOpen: false,
  }

  handleDelete = () => {
    return api.deleteMaintenanceTemplate({ templateId: this.props.maintenanceTemplate.id })
  }

  handleDeleteComplete = () => {
    this.setState({ modalOpen: true }, () => {
      this.props.setFilter(this.props.filterCriteria)
    })
  }

  render() {
    const { maintenanceTemplate } = this.props

    const message = `Are you you want to delete "${maintenanceTemplate.name}" maintenance template?`

    return (
      <ActionButton
        buttonColor={"#e33a30c4"}
        buttonIconName="times circle"
        buttonText="Delete Template"
        onPerformAction={this.handleDelete}
        onPerformActionComplete={this.handleDeleteComplete}
        confirmationTitle={message}
        confirmationHeader="Delete Maintenance Template"
      />
    )
  }
}

const mapDispatchToProps = {
  setFilter,
}
const mapStateToProps = (state) => ({
  filterCriteria: state.items.filterCriteria,
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteMaintenanceTemplateButton)
